// This file is generated from environment.prod.ts.template. Do not edit manually.

// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
export const environment = {
  production: true,
  apiKey: "nkdsQkLR5GkxZaggpNlKIUtzhAfYmAsc",
  managementApiUrl: "https://tecnalia.fersa-space.manufacturing.tecnalia.dev/mgmt",
  catalogUrl: "https://tecnalia.fersa-space.manufacturing.tecnalia.dev/catalog/v1alpha",
  publicApiUrl: "https://tecnalia.fersa-space.manufacturing.tecnalia.dev/public/",
  storageAccount: "company2assets",
  storageExplorerLinkTemplate: "storageexplorer://v=1",
  theme: "theme-2",
  accentColor: "#fc6203",
  accentLight: "#fca903",
  description: "Tecnalia EDC Connector Dashboard to interact with the EDC Connector deployed in FERSA SPACE.",
  maintainerOrganizationName: "Tecnalia",
  curatorOrganizationName: "Tecnalia",
  title: "EDC Connector Dashboard",
  curatorUrl: "https://www.tecnalia.es/",
  maintainerUrl: "https://www.tecnalia.com/",
  edcVersion: "0.13.0",
  connectorEndpoint: "https://tecnalia.fersa-space.manufacturing.tecnalia.dev/proto",
  participantId: "tecnalia-connector",
  connectors: {
    ideko: {
      name: "Ideko",
      address: "https://ideko.fersa-space.manufacturing.tecnalia.dev/proto"
    },
    tecnalia: {
      name: "Tecnalia",
      address: "https://tecnalia.fersa-space.manufacturing.tecnalia.dev/proto"
    },
    fersa: {
      name: "Tecnalia",
      address: "https://tecnalia.fersa-space.manufacturing.tecnalia.dev/proto"
    }
  },

  kcRealm: "datadashboard-authorization-portal",
  kcClientId: "datadashboard",
  kcUrl: "https://tecnalia.fersa-space.manufacturing.tecnalia.dev/keycloak/",
  edcUiLogoutUrl: "https://tecnalia.fersa-space.manufacturing.tecnalia.dev/",
  logoPath: "assets/logo.tecnalia.svg"
};
